import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";

const TeXTable = (props) => {
    
    if (!props.tex || !props.tex.length) {
        return null;
    }
    
    const tsrc = props.tex.replace(/\\/g, "").replace(/[{|}]/g, "").replace(/extbf/g, "").split("\n");
    const hd = <thead>{tsrc[0].split(":dh:").map((r) => 
        r.indexOf("multicolumn") > 0 ?
        <tr>{r.split("&").map((s) => (<th colSpan={s.indexOf("multicolumn") > 0 ? s.match(/multicolumn(\d)/)[1] : 1}><p align={s.indexOf("multicolumn") > 0 ? "center" : undefined}>{s.indexOf("multicolumn") > 0 ? s.replace(/multicolumn\w+\s/, "").trim() : s.trim()}</p></th>))}</tr> :
        <tr>{r.split("&").map((s) => (<th>{s.trim()}</th>))}</tr>
    )}</thead>;
    const tb = <tbody>{tsrc.slice(1).map((s) => s.trim() == "hline" ? <tr></tr> : (<tr>{s.split("&").map((s) => (<td>{s.trim()}</td>))}</tr>))}</tbody>;

    return (
        <Container style={{paddingTop: 10, paddingBottom: 20, width: props.width, margin: "0 auto"}} className="justify-content-md-left" fluid>
            <Row>
                <Col align="center">
                    <Table>
                        {hd}
                        {tb}
                    </Table>
                </Col>
            </Row>
            <Row>
                <p align="justify" style={{width: props.width, maxWidth: props.maxWidth, margin: "0 auto"}}><b>{`Table ${props.number}. `}</b>{props.caption}</p>
                <br/><br/><br/><br/>
            </Row>
        </Container>
    );
}

export default TeXTable;
